import { Box, SimpleGrid, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import classes from "./ExampleQuestions.module.css";
import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { useLogin, getToken } from "../../authConfig";
import { getExampleQuestionsApi } from "../../api";
import { useDomain } from "../../DomainContext";

export interface ExampleQuestionsProps {
    onClick: (value: string) => void;
}

export const ExampleQuestions = ({ onClick }: ExampleQuestionsProps) => {
    const { i18n } = useTranslation();
    const { domain } = useDomain();
    const client = useLogin ? useMsal().instance : undefined;
    const [questions, setQuestions] = useState<string[]>([]);

    useEffect(() => {
        async function load() {
            try {
                const idToken = client ? await getToken(client) : undefined;
                const data = await getExampleQuestionsApi(idToken, i18n.language, domain);
                const pool = data.questions.map(q => q.question);
                const picks: string[] = [];
                while (picks.length < 3 && pool.length > 0) {
                    const idx = Math.floor(Math.random() * pool.length);
                    picks.push(pool.splice(idx, 1)[0]);
                }
                setQuestions(picks);
            } catch {
                // silently fail — no questions shown
            }
        }
        load();
    }, [i18n.language, client, domain]);

    if (questions.length === 0) return null;

    return (
        <SimpleGrid cols={{ base: 1, xs: 3 }} spacing="md" verticalSpacing="md">
            {questions.map((q, i) => (
                <Box key={i} className={classes.questionBox} onClick={() => onClick(q)}>
                    <Text size="md" fw={500}>
                        {q}
                    </Text>
                </Box>
            ))}
        </SimpleGrid>
    );
};
